module.exports = __webpack_public_path__ + "static/img/she2.60dae8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/she2.png
// module id = KSIh
// module chunks = 5